import React from 'react';
import { Building2, TrendingDown, ShoppingCart, Truck, BadgeCheck, Star } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';

const iconMap = {
  Building2: Building2,
  TrendingDown: TrendingDown,
  ShoppingCart: ShoppingCart,
  Truck: Truck,
  BadgeCheck: BadgeCheck,
  Star: Star
};

const WhyChooseUs = () => {
  return (
    <section id="about" className="py-16 bg-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-accent/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-accent">ARIHANT SALES</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trusted by garment manufacturers, retailers, and sportswear brands across Madhya Pradesh
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="feature-card group"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-primary transition-colors duration-300">
                    <IconComponent size={28} className="text-primary group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-primary transition-colors">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust Badge Section */}
        <div className="mt-12 bg-gray-900 rounded-2xl p-8 lg:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Trusted by Leading Brands</h3>
          <p className="text-xl text-gray-300 mb-6 max-w-3xl mx-auto">
            Supplying premium fabrics to garment manufacturers, sportswear brands, and retailers across Jabalpur and nearby cities
          </p>
          <div className="flex flex-wrap justify-center gap-8 mt-8">
            <div className="text-center">
              <p className="text-4xl font-bold text-accent mb-1">20+</p>
              <p className="text-gray-300">Years in Business</p>
            </div>
            <div className="text-center">
              <p className="text-4xl font-bold text-accent mb-1">30+</p>
              <p className="text-gray-300">Fabric Varieties</p>
            </div>
            <div className="text-center">
              <p className="text-4xl font-bold text-accent mb-1">100%</p>
              <p className="text-gray-300">Quality Guaranteed</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
